import { c as _c } from "react/compiler-runtime";
import React, { ChangeEvent, FC } from 'react';
import { useFormik } from 'formik';
import Checkbox, { CheckboxProps } from '@/src/app/components/Checkbox/Checkbox';
import * as Yup from 'yup';
import { isRequiredField } from '@/src/lib/utils/form-helpers';
export type FormikCheckboxProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik?: ReturnType<typeof useFormik<any>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formikValidationSchema: Yup.ObjectSchema<any>;
  name: string;
} & CheckboxProps;
const FormikCheckbox: FC<FormikCheckboxProps> = t0 => {
  const $ = _c(19);
  const {
    formik,
    isRadio,
    required,
    disabled,
    label,
    labelClassName,
    description,
    name,
    id,
    value,
    formikValidationSchema
  } = t0;
  let t1;
  if ($[0] !== formik || $[1] !== name || $[2] !== value) {
    t1 = e => {
      if (!name || !formik) {
        return;
      }
      formik.setFieldValue(name, e.target.checked ? value : "");
    };
    $[0] = formik;
    $[1] = name;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onChange = t1;
  let t2;
  if ($[4] !== formikValidationSchema || $[5] !== name || $[6] !== required) {
    t2 = required || isRequiredField(formikValidationSchema, name);
    $[4] = formikValidationSchema;
    $[5] = name;
    $[6] = required;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const isRequired = t2;
  let t3;
  if ($[8] !== description || $[9] !== disabled || $[10] !== id || $[11] !== isRadio || $[12] !== isRequired || $[13] !== label || $[14] !== labelClassName || $[15] !== name || $[16] !== onChange || $[17] !== value) {
    t3 = <Checkbox label={label} labelClassName={labelClassName} description={description} isRadio={isRadio} name={name} id={id} value={value} required={isRequired} disabled={disabled} onChange={onChange} />;
    $[8] = description;
    $[9] = disabled;
    $[10] = id;
    $[11] = isRadio;
    $[12] = isRequired;
    $[13] = label;
    $[14] = labelClassName;
    $[15] = name;
    $[16] = onChange;
    $[17] = value;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
};
export default FormikCheckbox;